import React, {Component, Fragment} from 'react'
import {connect} from "react-redux";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactHtmlParser from 'react-html-parser';



import './recommendations.scss'
import Slider from 'react-slick';
import leftArrowGrey from 'assets/icons/arrow_left_grey.svg';
import leftArrowBlue from 'assets/icons/left_arrow_blue.svg';
import opinion from "assets/icons/opinion.svg";
import opinionDesktop from "assets/icons/opinion_desktop.svg";


class Recommendations extends Component{

    constructor(props){
        super(props);

        this.getReactSlide = this.getReactSlide.bind(this);
    }

    getReactSlide(info,key){
        const isDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop_large';
        return(
            <Fragment key={key}>
                <div className="recommendationSlideContainer">
                    <img className='opinionImg' src={isDesktop ? opinionDesktop : opinion} alt="recommendation"/>
                    <div className='opinionPara'>{ReactHtmlParser(info.description)}</div>
                    <div className='para'>
                        <strong className='strongPara'>
                            { ReactHtmlParser(info['recommender-name']) }
                        </strong>
                        ,&nbsp;
                        {ReactHtmlParser(info['extra-text'])}
                    </div>
                    {isDesktop &&
                    <Fragment>
                        <img src={leftArrowGrey} alt='\' className='slideArrow'/>
                        <img src={leftArrowGrey} alt='\' className='slideArrow prev'/>
                    </Fragment>
                    }
                </div>
            </Fragment>
        )
    }

    render(){

        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop_large';
        const slides = this.props.recommendations;


        const reactSlides = [];
        slides.data.map((slide,index) => (reactSlides.push(this.getReactSlide(slide,index))));

        let slideToShow = 1;
        let arrows = true;

        if(isLaptopOrDesktop){
            slideToShow = 2;
            arrows = false;
        }

        const initialSlide = Object.keys(slides.data).length - Math.floor(slideToShow);


        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: slideToShow,
            slidesToScroll: 1,
            autoplaySpeed:slides.config.seconds,
            autoplay:true,
            rtl:true,
            arrows:arrows,
            initialSlide: initialSlide,
            nextArrow:<ArrowNext large = {isLaptopOrDesktop}/>,
            prevArrow:<ArrowPrev large = {isLaptopOrDesktop}/>
        };

        return(
            <section className="recommendations">
                {isLaptopOrDesktop &&
                    <div className='dividerTop'/>
                }
                <h3 className="title">{this.props.text['recomendations_title']}</h3>
                {reactSlides.length > 0 &&
                    <Slider className={(reactSlides.length <= slideToShow ? '' : 'recommendationSlider')} {...settings}>
                        {reactSlides}
                    </Slider>
                }
            </section>
        )
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        recommendations: store.config.Recommendations,
        text: store.config.Translations,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {

    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Recommendations);

function ArrowPrev(props) {
    const {large,onClick} = props;
    if (large)
        return (
            <div className='arrow next' onClick={onClick}>
                <img className='arrowIcon' src={leftArrowGrey} alt='/'/>
            </div>
        );
    else
        return (<div className='arrow next' onClick={onClick}>
            <img className='arrowIcon' src={leftArrowBlue} alt='/'/>
        </div>);
}

function ArrowNext(props) {
    const {large,onClick} = props;
    if (large)
        return (
            <div className='arrow prev' onClick={onClick}>
                <img className='arrowIcon' src={leftArrowGrey} alt='/'/>
            </div>
        );
    else
        return (<div className='arrow prev' onClick={onClick}>
            <img className='arrowIcon' src={leftArrowBlue} alt='/'/>
        </div>);
}